import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'cyan' | 'magenta';
}

export function LoadingSpinner({ size = 'md', color = 'cyan' }: LoadingSpinnerProps) {
  return (
    <div className={`loading-spinner spinner-${size} spinner-${color}`}>
      <div className="spinner-ring"></div>
    </div>
  );
}

